import type { ICollectionResponseType } from '@/types/api-types/IApiResponse'

export default class CollectionResponse<T> {
  value: T[]

  constructor(collection: ICollectionResponseType) {
    this.value = collection.value
  }
}
